// MyWalletTransfer.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import './MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faFileAlt } from '@fortawesome/free-solid-svg-icons';


const MyWalletTransfer = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(authState.user._id);
  const [payerCode, setPayerCode] = useState(authState.user.think5whyscode);

  const [payerName, setPayerName] = useState(authState.user.name);
  const [payeeId, setPayeeId] = useState('');
  const [payeeCode, setPayeeCode] = useState('');
  const [payeeName, setPayeeName] = useState('');
  const [payeeCountry, setPayeeCountry] = useState('');
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] =  useState(0);
  const [paymentClicked, setPaymentClicked] = useState(false);
  const [modePayment, setModePayment] = useState('Online');
  const [transactionId, setTransactionId] = useState('123456789');
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('');
  const [paymentDetails, setPaymentDetails] = useState('');
  const [error, setError] = useState(null);
  const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
  const [walletBalancePoints, setWalletBalancePoints] = useState(0);
  const [walletLastUpdated, setWalletLastUpdated] = useState();
  const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');
  const [payeeCodeStatus, setPayeeCodeStatus] = useState(false);
  const [payeeCodeStatusMsg, setPayeeCodeStatusMsg] = useState('');
  const [payeeCodeButtonClicked, setPayeeCodeButtonClicked] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(0.00);

  const [doWalletTopup, setDoWalletTopup] = useState(false);

//WalletBalance
const fetchWalletBalance = useCallback(() => {
  const config = {
      url: "/walletbalance",
      method: "get",
      headers: { Authorization: authState.token }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Wallet Balance Response:", response);
          if (response) {
              // setWalletBalanceAmount(response.balanceAmount);
              setWalletBalanceAmount(
                Number(response?.balanceAmount?.$numberDecimal ?? response?.balanceAmount ?? 0)
              );
              setWalletBalancePoints(response.balancePoints);
              setWalletLastUpdated(response.lastTransactionDate);
              setWalletLastUpdatedRemarks(response.remarks);
          } else {
              console.error("Invalid response format: Wallet not found in response");
              setWalletBalanceAmount(0.00);
              setWalletBalancePoints(0);
              setWalletLastUpdated(null);
              setWalletLastUpdatedRemarks('');
          }
      })
      .catch(error => {
          console.error("Error fetching wallet master:", error);
          setWalletBalanceAmount(0.00);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletBalance();
  }, [authState.isLoggedIn, fetchWalletBalance]);

  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    payeeCode: "",
    amount: "",
    remarks: ""
  });

  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  
  const payeeCodeValidationClicked = () => {
    // console.log("payeeCodeValidationClicked", formData);

    setPayeeCodeButtonClicked(true);
    
    // Validate Payee Code
    if (/^TU[a-zA-Z0-9]{12}$/.test(formData.payeeCode)) {
        // fetchPayeeCode(formData.payeeCode);
        // Validate Amount
        if (formData.amount <= 0 || !/^[0-9]+(\.[0-9]{1,2})?$/.test(formData.amount)) {
            setError("Error in Amount Input");
            return;
        }
        
        // Check Wallet Balance
        if (formData.amount > walletBalanceAmount) {
            setError("Your Wallet Balance has insufficient funds to make the transfer. Please recharge your Wallet.");
            setDoWalletTopup(true);
            return;
        }  

        if (formData.remarks=='') {
          setError("Transfer Remarks is required!!");
          return;
        }

        // Check for Self Transfer
        if (formData.payeeCode === payerCode) {
            setError(`Your Code is ${payerCode} and Payee Code is ${formData.payeeCode}. Self Transfer is not allowed!`);
            return;
          } 
          fetchPayeeCode(formData.payeeCode);
    } else {
        setError('Input a valid 14-character Think5Whys User Code starting with TU.');
    }
};


const fetchPayeeCode = useCallback((payeeCode) => {
  // console.log("payeeCode for API call ", payeeCode);
  const config = {
      url: "/auth/verifyreferralcode",
      method: "post",
      headers: { Authorization: authState.token },
      data: { think5whyscode: payeeCode }
  };

  fetchData(config)
      .then(response => {
        // console.log("API Response: ", response); 
          if (response && response.status) {
              // console.log("fetchPayeeCode found ", response);
              setPayeeCodeStatus(true);
              setPayeeId(response.t5wcode._id);
              setPayeeName(response.t5wcode.name);
              setPayeeCountry(response.t5wcode.country);
              setPayeeCodeStatusMsg("Payee Code found. 😊");
              // console.log("Payee Code found");
          } else {
              // console.log("Payee Code Not found");
              setPayeeCodeStatus(false);
              setPayeeCodeStatusMsg(`Payee Code ${payeeCode} not found! 😔 Make sure the Payee Code is valid.`);
          }
      })
      .catch(error => {
          // console.log("Payee Code Not found!", error);
          setPayeeCodeStatus(false);
          setPayeeCodeStatusMsg("Error in getting data");
      });
}, [fetchData, authState.token]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, fetchPayeeCode]);

  const handleAddPayeeButtonClick = () => {
    setPaymentClicked(true);
    saveWalletTransaction();
  };

  const saveWalletTransaction = async () => {
    const requestData = {
      payerName: payerName,
      payerId: userId,
      payeeId: payeeId,
      dateTransaction: new Date(),
      particulars: "Wallet Transfer to "+payeeName+" by "+payerName,
      amount: formData.amount,
      isSpecialPayer: isSpecialUser,
      splAmount: exchangeRate === 0.00 ? formData.amount : formData.amount * exchangeRate,
      currency: "Credits",
      inOut: 2,  //Transfer (Out)
      points: 0,
      wallet: "User Wallet",
      remarks: formData.remarks,
      modePayment: '"Think5Whys Wallet Transfer"',
      transactionId: 'D' + Date.now(),
      transactionDate: Date.now(),
      transactionStatus: 'Success',
      paymentDetails: 'NA',
      isActive: 1,
      isDeleted: 0,
      dateCreated: new Date(),
      createdBy: userId,
    };
  // console.log('Wallet Transfer data to be saved:', requestData);
    try {
      const config = { 
        url: `/wallet/transfer`, 
        method: "post", 
        data: requestData, 
        headers: { Authorization: authState.token } 
      };
      await fetchData(config);
      setPaymentStatus(true)
      navigate('/wallet-mywallet');
    } catch (error) {
      console.error('An error occurred while fetching data:', error);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const convertedAmount = exchangeRate && amount > 0 ? (amount * parseFloat(exchangeRate)).toFixed(2) : null;
  const isSpecialUser = authState?.user?.think5whyscode === "TU243BM5850150" && authState?.user?.isActive;
  const isCountryValid = payeeCountry === authState?.user?.country || isSpecialUser;
  const isTransferDisabled = paymentClicked || !payeeCountry || payeeCountry !== authState?.user?.country;

  const transferAmount = isSpecialUser && payeeCountry && authState?.user?.country && payeeCountry !== authState.user.country
    ? (parseFloat(formData.amount || 0) * parseFloat(exchangeRate || 0)).toFixed(2)
    : parseFloat(formData.amount || 0).toFixed(2);

  return (
    <div>
      <div className="mx-auto p-2 bg-black text-white [&_p]:text-white min-h-screen flex flex-col">
        <h2 className="text-sm lg:text-lg text-yellow-200 font-semibold mb-2 border-b border-gray-600 pb-1">🔄 Think5Whys User FuelStash Credits Exchange</h2>

        <div className="flex-grow bg-gray-800 p-6 rounded-lg shadow-lg">
          <div className="mb-2 bg-gradient-to-br from-[#111827] to-[#1f2937] border border-cyan-500/20 rounded-2xl p-4">
            <div className="flex items-center justify-between bg-green-500/10 border border-green-500/20 rounded-xl px-4 py-3">
                <div>
                    <div className="text-xs lg:text-sm text-green-300 uppercase tracking-wide">
                        Available Credits 
                    </div>

                    <div className="text-xs lg:text-sm text-gray-400">
                        Ready for transfer
                    </div>
                </div>
                <div className="text-sm lg:text-lg font-black text-green-400">
                    {walletBalanceAmount.toFixed(2)} 
                </div>
            </div>

            <div className="mt-2 bg-cyan-500/5 border border-cyan-500/10 rounded-xl p-2">
                <div className="flex items-center gap-2 text-cyan-300 font-bold text-sm">
                    👤 Payee/Recepient Info
                </div>
                <div className="mt-1 text-xs text-gray-300 leading-6">
                  <div className="mt-1 text-xs lg:text-sm bg-[#111827] rounded-lg px-2 py-1 border border-gray-700 inline-block">
                      Enter the Payee / Recipient's <span className="text-white text-xs lg:text-sm font-semibold">14-character Think5Whys ID / Code</span>.
                      <span className="ml-2 text-sm lg:text-sm text-yellow-300 font-mono">
                          Example: TU243AM5850150
                      </span>
                    </div>
                    <div className="text-xs lg:text-sm text-gray-300 mt-1">
                        Ask your Recepient to share their ID from: 
                        <span className='text-xs lg:text-sm text-cyan-300'>Home → SnapID</span>
                    </div>
                </div>
            </div>
            <div className="mt-1 bg-yellow-500/5 border border-yellow-500/10 rounded-xl p-1">
                <div className="mt-1 flex items-center justify-between bg-[#111827] rounded-xl px-2 py-1 border border-yellow-500/20">
                    <div className="text-xs lg:text-sm text-gray-400">
                        Your Think5Whys ID/Code:
                    </div>
                    <div className="font-mono text-sm lg:text-lg font-bold text-yellow-300 tracking-wider">
                        {authState?.user?.think5whyscode}
                    </div>
                </div>
            </div>
        </div>

          <div className="mb-1 flex flex-col gap-1 bg-yellow-500/5 border border-yellow-500/10 rounded-xl p-1">
            <div className="flex flex-col items-center">
               <label className="text-xs lg:text-sm text-cyan-300 font-semibold">
                  Payee Code
                </label>
              <input
                type="text"
                name="payeeCode"
                id="payeeCode"
                value={formData.payeeCode}
                placeholder="Input Payee Code"
                onChange={handleChange}
                className="w-full max-w-md py-1 px-1 text-xs lg:text-sm text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Payee Code")}
            </div>

            <div className="flex flex-col items-center">
               <label className="text-xs lg:text-sm text-cyan-300 font-semibold">
                  Amount
                </label>
              <input
                type="number"
                name="amount"
                id="amount"
                value={formData.amount}
                placeholder="Input Amount"
                onChange={handleChange}
                min="1"
                max="500000"
                style={{width: "50%"}}
                className="w-full max-w-md py-1 px-1 text-xs lg:text-sm text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Amount")}
            </div>
            <div className="flex flex-col items-center">
               <label className="text-xs lg:text-sm text-cyan-300 font-semibold">
                  Remarks
                </label>              
              <input
                type="text"
                name="remarks"
                id="remarks"
                value={formData.remarks}
                placeholder="Input Remarks"
                onChange={handleChange}
                style={{width: "100%"}}
                className="w-full max-w-md py-1 px-1 text-xs lg:text-sm text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Remarks")}
            </div>

            <div className="flex flex-row justify-center mb-2">
              <button
                type="button"
                disabled={walletBalanceAmount <= 0 || payeeCodeStatus || 
                          !formData.payeeCode?.trim() || !formData.amount || !formData.remarks?.trim()}
                className={`text-xs lg:text-sm w-fit px-4 py-1 rounded-lg shadow-md transition duration-300 ${
                  walletBalanceAmount <= 0 || payeeCodeStatus
                    ? "bg-gray-500 cursor-not-allowed text-gray-300"
                    : "bg-green-600 hover:bg-green-700 text-white"
                }`}
                onClick={payeeCodeValidationClicked}
              >
                {payeeCodeStatus
                  ? "Payee Code Validated"
                  : "Validate Payee Code"}
              </button>
              <button
                onClick={handleCancel}
                className="text-xs lg:text-sm w-fit bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-4 rounded-lg shadow-md transition duration-300"
              >
                Cancel
              </button>
            </div>

            {error && (
              <div className="mb-2 text-center">
                <p className="text-red-500 text-xs lg:text-sm">{error}</p>
              </div>
            )}
          </div>

          <div className="text-center text-white mb-2">
            <p
              style={{ color: payeeCodeStatus === true ? "lime" : "red" }}
              className="text-xs lg:text-sm font-bold"
            >
              {payeeCodeStatusMsg}
            </p>
          </div>

        {/* { doWalletTopup && (
          <div className="mb-2 text-center flex flex-row">
            <button
              onClick={() => navigate("/wallet-topup")}
              className="text-xs lg:text-sm w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
            >
              Topup 
            </button>
          </div>
          )} */}
            
          {payeeCodeStatus && (
            <>
              <div className="mb-4 bg-[#111827] border border-gray-700 rounded-2xl p-4">
                <div className="text-sm font-bold text-cyan-300 mb-3">
                    🌍 Transfer Validation
                </div>
                <div className="space-y-2">
                    <div className="flex justify-between items-center bg-gray-800/50 rounded-lg px-3 py-2">
                        <span className="text-gray-300 text-xs lg:text-sm">
                            👤 Payee Name
                        </span>
                        <span className="font-semibold text-yellow-300 text-xs lg:text-sm">
                            {payeeName || "Not Available"}
                        </span>
                    </div>
                    <div className="flex justify-between items-center bg-gray-800/50 rounded-lg px-3 py-2">
                        <span className="text-gray-300 text-xs lg:text-sm">
                            🌎 Payee Country
                        </span>
                        <span
                            className={`text-xs lg:text-sm font-semibold ${
                                payeeCountry
                                    ? "text-green-400"
                                    : "text-red-400"
                            }`}
                        >
                            {payeeCountry || "Missing"}
                        </span>
                    </div>
                    <div className="flex justify-between items-center bg-gray-800/50 rounded-lg px-3 py-2">
                        <span className="text-gray-300 text-xs lg:text-sm">
                            🏠 Your Country
                        </span>
                        <span
                            className={`text-xs lg:text-sm font-semibold ${
                                authState?.user?.country
                                    ? "text-green-400"
                                    : "text-red-400"
                            }`}
                        >
                            {authState?.user?.country || "Missing"}
                        </span>
                    </div>
                </div>

                <div className="mt-2 space-y-2">
                    {!payeeCountry && (
                        <div className="bg-red-500/10 border border-red-500/20 text-red-300 rounded-lg px-1 py-1 text-xs lg:text-sm">
                            ❌ Payee country is not available.
                        </div>
                    )}
                    {!authState?.user?.country && (
                        <div className="bg-red-500/10 border border-red-500/20 text-red-300 rounded-lg px-1 py-1 text-xs lg:text-sm">
                            ❌ Your country is not available.
                        </div>
                    )}
                    {payeeCountry && authState?.user?.country && payeeCountry !== authState.user.country && (
                            <div className="bg-yellow-500/10 border border-yellow-500/20 text-yellow-300 rounded-lg px-1 py-1 text-xs lg:text-sm">
                                ⚠️ Transfers are only allowed when both countries match.
                            </div>
                        )}
                    {payeeCountry && authState?.user?.country && payeeCountry === authState.user.country && (
                            <div className="bg-green-500/10 border border-green-500/20 text-green-300 rounded-lg px-2 py-1 text-xs lg:text-sm font-medium">
                                ✅ Country validation passed. Transfer allowed.
                            </div>
                        )}
                </div>
            </div>

            {isSpecialUser && payeeCountry && authState?.user?.country && payeeCountry !== authState.user.country && (
              <div className="mt-1 bg-red-900/20 border border-red-500/40 rounded-lg p-4">
                {isSpecialUser && (
                  <div className="mt-1 text-xs lg:text-sm text-green-300 bg-green-500/10 border border-green-500/20 rounded-lg px-3 py-2">
                    💱 Converted Credit in ₹: {exchangeRate * formData.amount}
                  </div>
                )}
                <label className="text-xs lg:text-sm text-red-300 font-bold flex items-center gap-2">
                  ⚠ Exchange Rate (Required)
                </label>
                <input
                  type="number"
                  step="0.0001"
                  min="0.0001"
                  value={exchangeRate}
                  onChange={(e) => {
                    const val = e.target.value;
                    // allow empty for typing, but block invalid final values
                    if (val === "") {
                      setExchangeRate("");
                      return;
                    }
                    const num = parseFloat(val);
                    // block zero or negative
                    if (num <= 0) return;
                    setExchangeRate(val);
                  }}
                  placeholder="Enter valid exchange rate (e.g. 0.85)"

                  className="mt-1 px-1 py-1 rounded-lg bg-gray-900 text-white border border-red-400 focus:border-red-300 outline-none font-semibold"
                />

                {/* validation warning */}
                {(!exchangeRate || parseFloat(exchangeRate) <= 0) && (
                  <p className="mt-1 text-xs lg:text-sm text-red-400 font-medium">
                    Exchange rate is required and must be greater than 0
                  </p>
                )}
              </div>
            )}


            <div className="mb-1 text-center flex flex-row">
{/* <div>exchangeRate: {JSON.stringify(exchangeRate)}</div> */}
                <button
                  onClick={handleAddPayeeButtonClick}
                  disabled={(!isSpecialUser && isTransferDisabled) ||
                    ( isSpecialUser && payeeCountry && authState?.user?.country &&
                      payeeCountry !== authState.user.country &&
                      (!exchangeRate || parseFloat(exchangeRate) <= 0)
                    )
                  }
                  className="w-fit bg-green-600 text-xs lg:text-sm text-white px-1 py-1 rounded-lg shadow-md hover:bg-orange-600"
                >
                  Confirm Transfer of {transferAmount} to {payeeName}
                </button>
                <button
                  onClick={handleCancel}
                  className="w-fit bg-blue-500 hover:bg-blue-600 text-xs lg:text-sm text-white font-bold py-1 px-2 rounded-lg shadow-md"
                >
                  Cancel
                </button>
              </div>

              {paymentClicked && (
                <div className="text-center">
                  {paymentStatus ? (
                    <p className="text-green-500 text-xs lg:text-sm">Transferred Credits {parseFloat(formData.amount).toFixed(2)} to {payeeName}'s Wallet</p>
                  ) : (
                    <p className="text-red-500 text-xs lg:text-sm">Transfer of Credits {parseFloat(formData.amount).toFixed(2)} to {payeeName} Failed. Please Retry.</p>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
      <div className="rounded-xl border border-gray-800 bg-gray-900 p-3 text-center">
          <div className="text-[11px] text-gray-400">
              ⚡ Think5Whys FuelStash • Simple. Fast. Transparent. Global.
          </div>
      </div>
    </div>
  );
};

export default MyWalletTransfer;
